
import { useState, useEffect } from 'react';
import { useOnboardingContext } from '@/context/OnboardingContext';

// Types - Remove 'phone' from the steps
export type OnboardingStep = 'install' | 'info' | 'email' | 'verification' | 'success';

export const useOnboardingState = () => {
  const { loadUserData } = useOnboardingContext();
  const [step, setStep] = useState<OnboardingStep>('install');
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [expectedOtp, setExpectedOtp] = useState("");
  const [resendDisabled, setResendDisabled] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const [emailError, setEmailError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Save current step to localStorage for persistence
  useEffect(() => {
    localStorage.setItem('currentOnboardingStep', step);
    console.log('Current onboarding step saved:', step);
  }, [step]);

  // Check for existing onboarding state on initial load
  useEffect(() => {
    // If the user is already on the 'success' step, we shouldn't reset the state
    if (step !== 'success') {
      // Get the existing app installation status
      const appInstalled = localStorage.getItem('appInstalled');
      if (appInstalled === 'true') {
        // Only advance to info step if we're not already at a later step
        if (step === 'install') {
          setStep('info');
        }
      }
    }
  }, [step]);

  // Reset countdown timer when an OTP is sent
  useEffect(() => {
    let timer: NodeJS.Timeout;
    
    if (resendDisabled && countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else if (countdown === 0 && resendDisabled) {
      setResendDisabled(false);
    }
    
    return () => clearTimeout(timer);
  }, [resendDisabled, countdown]);

  return {
    step,
    setStep,
    name,
    setName,
    email,
    setEmail,
    phoneNumber,
    setPhoneNumber,
    phoneError,
    setPhoneError,
    expectedOtp,
    setExpectedOtp,
    resendDisabled,
    setResendDisabled,
    countdown,
    setCountdown,
    emailError,
    setEmailError,
    isLoading,
    setIsLoading,
    loadUserData
  };
};
